import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body justify-content-between d-flex flex-column overflow-hidden" }
const _hoisted_3 = { class: "mb-2 align-items-center" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-8 align-self-center text-truncate small fw-bold mb-0 pe-0" }
const _hoisted_6 = { class: "col-4 text-nowrap overflow-hidden text-end small" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = { class: "small ms-1" }
const _hoisted_9 = {
  key: 1,
  class: "badge bg-danger rounded-pill"
}
const _hoisted_10 = { class: "row align-items-center small" }
const _hoisted_11 = { class: "col-12 small text-nowrap text-end" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "pt-1" }
const _hoisted_14 = { class: "row align-items-stretch" }
const _hoisted_15 = { class: "col-8 align-self-center fw-bold text-truncate small fw-bold mb-0 pe-0" }
const _hoisted_16 = { class: "col-4 text-nowrap overflow-hidden text-end small" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_18 = { class: "small ms-1" }
const _hoisted_19 = {
  key: 1,
  class: "badge bg-danger rounded-pill"
}
const _hoisted_20 = { class: "row align-items-center small" }
const _hoisted_21 = { class: "col-12 small text-nowrap text-end" }
const _hoisted_22 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "card-header d-flex align-items-center text-nowrap" }, [
      _createElementVNode("i", { class: "far fa-calendar-alt me-2" }),
      _createTextVNode("Estatus Suscripciones")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_package_icon, {
              product: _ctx.level,
              colored: "",
              "extra-class": "me-2"
            }, null, 8, ["product"]),
            _createTextVNode(_toDisplayString(_ctx.packageName), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.packageSubscription.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge rounded-pill", _ctx.daysLeftClass(_ctx.packageSubscription.daysLeft || 0)])
                  }, _toDisplayString(_ctx.packageSubscription.daysLeft), 3),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.packageDurationUnitLocalized), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "INACTIVA"))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.packageFormattedEndDate), 1)
          ])
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row pt-2 border-top" }, null, -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_package_icon, {
              product: "distributor-license",
              colored: "",
              "extra-class": "me-1"
            }),
            _cache[0] || (_cache[0] = _createTextVNode("Licencia de Distribuidor", -1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.distributorLicenseSubscription.isActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge rounded-pill", 
                  _ctx.daysLeftClass(_ctx.distributorLicenseSubscription.daysLeft || 0)
                ])
                  }, _toDisplayString(_ctx.distributorLicenseSubscription.daysLeft), 3),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.licenseDurationUnitLocalized), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, "INACTIVA"))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.licenseFormattedEndDate), 1)
          ])
        ])
      ])
    ])
  ]))
}